import React, { useState } from 'react';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import { useTranslation } from 'react-i18next';
  
const BackOrderCardContainer = ({
    children,
    itemCount,
    mobileContainerMargin,
    marginContainer,
    paddingContainer,
}) => {
    const [expandedCard, setExpandedCard] = useState(true);
    const toggleCard = () => {
        setExpandedCard(!expandedCard);
    };
    const { t } = useTranslation();
    return (
        <>
            <CollapsableCard
                id="common-backOrderCardContainer-backOrderDetails-items"
                title={`${t('common.itemsLabel')}(${itemCount})`}
                onClick={toggleCard}
                isExpanded={expandedCard}
                margin={marginContainer}
                padding={paddingContainer}
                mobileMargin={mobileContainerMargin}
            >
                {expandedCard ? children : null}
            </CollapsableCard>
        </>
    );
};

export default BackOrderCardContainer;
